import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { Store } from '../../../store/player/types';

/**
 * Side panel toggle.
 */
export const toggleSidePanel = (store: Store, forceOpenTab?: boolean): void => {
  const { setShowSidePanel, showSidePanel } = store.getState();
  setShowSidePanel(forceOpenTab ?? !showSidePanel);
  LocalStorage.set('playbackShowSidePanel', forceOpenTab);
};
